import Flux from 'lib/flux';

const LandingConstants = Flux.createConstants({
  serviceMessages: ['FETCH_TOURS'],
});

export default LandingConstants;
